import { useExperimentStore, useLanguageStore, useUserStore } from '@/helpers/composables/useStores';
import BuyboxLoggedIn, { BuyboxLoggedInExpVariants, BuyboxLoggedInExpAffiliateTags, BuyboxLoggedInExpName } from '..';
import { computed } from 'vue';
import { injectLocal, provideLocal, useMounted } from '@vueuse/core';
import { ExperimentTrackEventOptions } from '@/components/experiments/Core/types';

type offerTypes = 'RO' | 'FT' | 'QTV';
const getProviderExpAffiliateParams = (
	variant: BuyboxLoggedInExpVariants,
	providerShortName: string,
	offerType: offerTypes
) => {
	const byVariant = BuyboxLoggedInExpAffiliateTags[variant];
	const byProvider = providerShortName in byVariant ? byVariant[providerShortName] : null;
	if (byProvider) {
		return byProvider[offerType];
	}
	return null;
};

const experimentSymbol = Symbol('BuyboxLoggedInExp');

export type TrackBuyboxLoggedInExp = ReturnType<typeof useBuyboxLoggedInExp>['trackBuyboxLoggedInExp'];

export const useBuyboxLoggedInExp = (isExpActiveCondition?: boolean) => {
	const { activeVariantsWithControlGroup } = useExperimentStore();
	const { country } = useLanguageStore();
	const { isLoggedIn } = useUserStore();
	const isMounted = useMounted();

	if (isExpActiveCondition) {
		provideLocal(experimentSymbol, true);
	}

	const isExpActive = injectLocal(experimentSymbol, false);

	const expActiveVariant = computed(() => {
		return undefined;
		// if (!isMounted.value || !!titlePageActiveVariant.value || !isLoggedIn.value || !isExpActive) {
		// 	return undefined;
		// }
		// return activeVariantsWithControlGroup.value[BuyboxLoggedInExpName] as BuyboxLoggedInExpVariants | undefined;
	});

	const getProviderAffiliateParams = (providerShortName: string, offerType: offerTypes) => {
		if (!expActiveVariant.value) {
			return null;
		}

		const affiliatTags = getProviderExpAffiliateParams(expActiveVariant.value, providerShortName, offerType);

		const amzSuffix = {
			US: '-20',
			GB: '-21',
			DE: '-21',
			FR: '-21',
		};

		const suffix = ['amp', 'prv'].includes(providerShortName)
			? amzSuffix[country.value as keyof typeof amzSuffix] || ''
			: '';
		if (affiliatTags) {
			return {
				...affiliatTags,
				ct: affiliatTags.ct.replace('<country>', country.value.toLowerCase()) + suffix,
			};
		}
		return null;
	};

	function trackBuyboxLoggedInExp(TrackingOptions: ExperimentTrackEventOptions<BuyboxLoggedInExpVariants>) {
		if (expActiveVariant.value) {
			BuyboxLoggedIn.trackEvent({
				property: 'buybox_loggedIn',
				...TrackingOptions,
			});
		}
	}

	return {
		getProviderAffiliateParams,
		trackBuyboxLoggedInExp,
		expActiveVariant,
	};
};
